export { default } from "./resolveComponentProps.js";